var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 4.375H5.625V3.125H6.875M6.875 9.375H5.625V5.625H6.875M6.25 0C5.42924 0 4.61651 0.161661 3.85823 0.475753C3.09994 0.789845 2.41095 1.25022 1.83058 1.83058C0.65848 3.00269 0 4.5924 0 6.25C0 7.9076 0.65848 9.49732 1.83058 10.6694C2.41095 11.2498 3.09994 11.7102 3.85823 12.0242C4.61651 12.3383 5.42924 12.5 6.25 12.5C7.9076 12.5 9.49732 11.8415 10.6694 10.6694C11.8415 9.49732 12.5 7.9076 12.5 6.25C12.5 5.42924 12.3383 4.61651 12.0242 3.85823C11.7102 3.09994 11.2498 2.41095 10.6694 1.83058C10.0891 1.25022 9.40006 0.789845 8.64177 0.475753C7.88349 0.161661 7.07076 0 6.25 0Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNoteIcon);
export default __webpack_public_path__ + "static/media/warning-note-icon.2d2b7753a9d2747bfc857dbebc9fef26.svg";
export { ForwardRef as ReactComponent };